import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UserInterface } from 'redux/slices/userSlice';
import { enviroments } from 'utils/constants';

export const userServiceApi = createApi({
  reducerPath: 'userServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
  }),
  endpoints: (builder) => ({
    createUserAnonymous: builder.mutation<any, any>({
      query: (params: UserInterface) => ({
        url: 'user/create-user-anonimous',
        method: 'POST',
        body: params,
      }),
    }),

    createUserRegistred: builder.mutation<any, any>({
      query: (params: UserInterface) => ({
        url: '/user/create-user-registered',
        method: 'POST',
        body: params,
        headers: {
          authorization: 'Bearer ',
        },
      }),
    }),

    signUpUser: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/create-user-registered',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    loginUser: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/login',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    activateUser: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/activate-user',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    resetPwdNoLoggedUserInit: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/init-recovery-pwd',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    resetPwdNoLoggedUserEnd: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/end-recovery-pwd',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    editUser: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/',
        method: 'PUT',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    deleteUser: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'user/',
        method: 'DELETE',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    editUserPass: builder.mutation<any, any>({
      query: ({ token }) => ({
        url: 'user/change-pass/',
        method: 'PUT',
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
  }),
});

export const {
  useCreateUserAnonymousMutation,
  useCreateUserRegistredMutation,
  useSignUpUserMutation,
  useLoginUserMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useEditUserPassMutation,
  useActivateUserMutation,
  useResetPwdNoLoggedUserInitMutation,
  useResetPwdNoLoggedUserEndMutation,
} = userServiceApi;
